import { MaintenanceTaskInterface } from "module/maintenanceTask/types";
import { MaintenanceTaskDefinitionType } from "pages/maintenanceTaskList/types";

export const isMaintenanceTaskProcessStepToolsAndEquipmentAvailable = (
  maintenanceTask: MaintenanceTaskInterface
): boolean =>
  !maintenanceTask.definitionType ||
  maintenanceTask.definitionType === MaintenanceTaskDefinitionType.equipment ||
  maintenanceTask.definitionType === MaintenanceTaskDefinitionType.system;
